<!-- スピナー -->
@if (showSpinner) {
  <div class="spinner">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
}

@if (isPermissionOpen) {
  <div class="permission-overlay" (click)="togglePermission()">
    <div class="permission-panel" (click)="$event.stopPropagation()">
      <div class="text-content">{{ authDescription }}</div>
    </div>
  </div>
}

<!-- 編集フォーム -->
@if (!showSpinner) {
  <div class="edit-container">
    <!-- 左サイドメニュー -->
    <div class="side-menu">
      <button
        mat-raised-button
        class="save-btn"
        [disabled]="isSaving || !draftTitleValid"
        (click)="onSave()"
      >
        @if (isSaving) {
          <mat-spinner diameter="16"></mat-spinner>
        } @else {
          保存
        }
      </button>
      <button
        mat-raised-button
        class="cancel-btn"
        (click)="onCancel()"
      >戻る</button>
    </div>

    <!-- メインエリア -->
    <div class="main-area">
      <!-- ヘッダー -->
      <div class="edit-header">
        <h2 class="edit-title">{{ documentType === 'plan' ? '企画書' : '報告書' }} 編集</h2>
        <span class="status-badge" [class]="'status-' + form.status">{{ statusLabel }}</span>
      </div>

      <!-- フォームテーブル -->
      <div class="form-table">

        <!-- タイトル -->
        <div class="form-row">
          <div class="form-label text">タイトル <span class="required">※</span></div>
          <div class="form-field">
            <div class="field-with-count">
              <span class="char-count">{{ form.title.length }} / 50</span>
              <input type="text" class="text-input" [(ngModel)]="form.title" maxlength="50" placeholder="タイトルを入力">
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- カテゴリー -->
        <div class="form-row">
          <div class="form-label">カテゴリー <span class="required">※</span></div>
          <div class="form-field">
            <div class="category-row large">
              <span class="sub-label">大分類</span>
              <span class="category-major-text">{{ categoryMajorName }}</span>
              @if (showPrivateCategoryNotice) {
                <span class="private-notice category">
                  このカテゴリーは他組織へ非公開です。
                </span>
              }
            </div>
            @if (form.categoryId && categorySubOptions.length > 0) {
              <div class="category-row">
                <span class="sub-label check">中分類</span>
                <div class="category-sub-area">
                  <span class="category-sub-note">
                    ※ 優先度の高い順に最大3つまで選択
                  </span>
                <div [class]="'checkbox-grid cols-' + fitGridCols(categorySubOptions, categorySubGridCols, 70)">
                  @for (item of categorySubOptions; track item.id) {
                    <label class="priority-checkbox"
                      [class.checked]="isInPriority(form.categorySub, item.id)"
                      [class.disabled]="isPriorityDisabled(form.categorySub, item.id, 3)"
                      (click)="togglePriority(form.categorySub, item.id, 3); $event.preventDefault()">
                      @if (getPriorityNum(form.categorySub, item.id); as num) {
                        <span class="priority-num">{{ num }}</span>
                      } @else {
                        <input type="checkbox" class="priority-checkbox-native" [checked]="false" tabindex="-1"
                          [disabled]="isPriorityDisabled(form.categorySub, item.id, 3)">
                      }
                      {{ item.name }}
                    </label>
                  }
                </div>
              </div>
            </div>
            }
          </div>
          <div class="form-action">
            @if (form.categoryId && categorySubOptions.length > 0) {
              <button class="reset-btn" (click)="resetPriority(form.categorySub)">× リセット</button>
            }
          </div>
        </div>

        <!-- 公開範囲 -->
        <div class="form-row one-row top-align">
          <div class="form-label"> @if (authDescription.length != 0) {<div class="permission-trigger" (click)="togglePermission()"><mat-icon class="icon" >info</mat-icon></div>} 公開範囲 <span class="required">※</span></div>
          <div class="form-field">
            <div class="public-scope-list">
              @for (item of publicScopeOptions; track item.id) {
                <div class="public-scope-item">
                  <label class="radio-label public-scope-radio">
                    <input type="radio" name="publicScope" [(ngModel)]="form.publicScope" [value]="item.id">
                    {{ item.name }}
                  </label>
                  @if (getPublicScopeRolePrefix(item.id)) {
                    <div class="public-scope-roles-inline">
                      <span class="public-scope-roles-prefix">{{ getPublicScopeRolePrefix(item.id) }}<span class="prefix-colon">：</span></span>
                      <span class="public-scope-roles-names">
                        @for (name of getPublicScopeRoleNames(item.id); track $index; let last = $last) {
                          <span class="public-scope-role-block">{{ name }}{{ last ? '' : '、' }}</span>
                        } @empty {
                          なし
                        }
                      </span>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 課題認識 -->

        @if (showIssueSection) {
          <!--
          <div class="form-row">
            <div class="form-label check">課題認識 <span class="required">※</span></div>
            <div class="form-field">
              <div [class]="'checkbox-grid cols-' + fitGridCols(getMasterItems('issue_awareness'), 3)">
                @for (item of getMasterItems('issue_awareness'); track item.id) {
                  <label class="priority-checkbox"
                    [class.checked]="isInPriority(form.issueAwareness, item.id)"
                    [class.disabled]="isPriorityDisabled(form.issueAwareness, item.id, 3)"
                    (click)="togglePriority(form.issueAwareness, item.id, 3); $event.preventDefault()">
                    @if (getPriorityNum(form.issueAwareness, item.id); as num) {
                      <span class="priority-num">{{ num }}</span>
                    } @else {
                      <input type="checkbox" class="priority-checkbox-native" [checked]="false" tabindex="-1"
                        [disabled]="isPriorityDisabled(form.issueAwareness, item.id, 3)">
                    }
                    {{ item.name }}
                  </label>
                }
              </div>
            </div>
            <div class="form-action">
              <button class="reset-btn" (click)="resetPriority(form.issueAwareness)">× リセット</button>
            </div>
          </div>
          -->

          <!-- 課題の根拠 -->
           <!--
          <div class="form-row">
            <div class="form-label select">課題の根拠 <span class="required"></span></div>
            <div class="form-field">
              <div class="inline-selects">
                <mat-form-field appearance="fill" class="no-line select-w230">
                  <mat-select [(ngModel)]="form.issueBasis" [panelWidth]="getMasterItems('issue_basis') | optionPanelWidth : 230">
                    <mat-option [value]="null"></mat-option>
                    @for (item of getMasterItems('issue_basis'); track item.id) {
                      <mat-option [value]="item.id">{{ item.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <span class="select-label">対象区分</span>
                <mat-form-field appearance="fill" class="no-line">
                  <mat-select [(ngModel)]="form.basisTargetDivision" [panelWidth]="getMasterItems('basis_target_division') | optionPanelWidth : 210">
                    <mat-option [value]="null"></mat-option>
                    @for (item of getMasterItems('basis_target_division'); track item.id) {
                      <mat-option [value]="item.id">{{ item.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <span class="select-label">対象期間</span>
                <mat-form-field appearance="fill" class="no-line">
                  <mat-select [(ngModel)]="form.basisTargetPeriod" [panelWidth]="getMasterItems('basis_target_period') | optionPanelWidth : 210">
                    <mat-option [value]="null"></mat-option>
                    @for (item of getMasterItems('basis_target_period'); track item.id) {
                      <mat-option [value]="item.id">{{ item.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
          -->

          <!-- 改善したい指標 -->
           <!--
          <div class="form-row">
            <div class="form-label select">改善したい指標 <span class="required">※</span></div>
            <div class="form-field">
              <div class="inline-selects">
                <span class="select-label first">状態の変化</span>
                <mat-form-field appearance="fill" class="no-line wide">
                  <mat-select [(ngModel)]="form.improvementIndicatorState" [panelWidth]="getMasterItems('improvement_indicator_state') | optionPanelWidth : 270">
                    @for (item of getMasterItems('improvement_indicator_state'); track item.id) {
                      <mat-option [value]="item.id">{{ item.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                @if (showImprovementOutcome) {
                  <span class="select-label">企画の成果</span>
                  <mat-form-field appearance="fill" class="no-line wide">
                    <mat-select [(ngModel)]="form.improvementIndicatorOutcome" [panelWidth]="getMasterItems('improvement_indicator_outcome') | optionPanelWidth : 270">
                      @for (item of getMasterItems('improvement_indicator_outcome'); track item.id) {
                        <mat-option [value]="item.id">{{ item.name }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              </div>
            </div>
            <div class="form-action"></div>
          </div>
          -->

          <!-- 改善したい指標 -->
          <div class="form-row">
            <div class="form-label">改善したい指標 <span class="required">※</span></div>
              <div class="form-field">
                <div class="category-row">
                  <span class="sub-label">状態の変化</span>
                  <div class="category-sub-area">
                    <span class="category-sub-note first">
                      ※ 優先度の高い順に最大3つまで選択
                    </span>
                    <div [class]="'checkbox-grid cols-' + fitGridCols(getMasterItems('improvement_indicator_state'), categorySubGridCols, 102)">
                      @for (item of getMasterItems('improvement_indicator_state'); track item.id) {
                        <label class="priority-checkbox"
                          [class.checked]="isInPriority(form.improvementIndicatorState, item.id)"
                          [class.disabled]="isPriorityDisabled(form.improvementIndicatorState, item.id, 3)"
                          (click)="togglePriority(form.improvementIndicatorState, item.id, 3); $event.preventDefault()">
                          @if (getPriorityNum(form.improvementIndicatorState, item.id); as num) {
                            <span class="priority-num">{{ num }}</span>
                          } @else {
                            <input type="checkbox" class="priority-checkbox-native" [checked]="false" tabindex="-1"
                              [disabled]="isPriorityDisabled(form.improvementIndicatorState, item.id, 3)">
                          }
                          {{ item.name }}
                        </label>
                      }
                    </div>
                  </div>
                </div>
              </div>
            <div class="form-action">
              <button class="reset-btn" (click)="resetPriority(form.improvementIndicatorState)">× リセット</button>
            </div>
          </div>
          @if (showImprovementOutcome) {
            <div class="form-row">
              <div class="form-label"></div>
              <div class="form-field">
                <div class="category-row">
                  <div class="inline-selects under-check">
                      <span class="sub-label">企画の成果</span>
                      <mat-form-field appearance="fill" class="no-line wide">
                        <mat-select [(ngModel)]="form.improvementIndicatorOutcome" [panelWidth]="getMasterItems('improvement_indicator_outcome') | optionPanelWidth : 270">
                          @for (item of getMasterItems('improvement_indicator_outcome'); track item.id) {
                            <mat-option [value]="item.id">{{ item.name }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          }

          <!-- 目的 -->
          <div class="form-row">
            <div class="form-label check">目的 <span class="required">※</span></div>
            <div class="form-field">
              <div class="category-row">
                <div class="category-sub-area">
                  <span class="category-sub-note">
                    ※ 優先度の高い順に最大3つまで選択
                  </span>
                  <div [class]="'checkbox-grid cols-' + fitGridCols(getMasterItems('purpose'), 4)">
                    @for (item of getMasterItems('purpose'); track item.id) {
                      <label class="priority-checkbox"
                        [class.checked]="isInPriority(form.purpose, item.id)"
                        [class.disabled]="isPriorityDisabled(form.purpose, item.id, 3)"
                        (click)="togglePriority(form.purpose, item.id, 3); $event.preventDefault()">
                        @if (getPriorityNum(form.purpose, item.id); as num) {
                          <span class="priority-num">{{ num }}</span>
                        } @else {
                          <input type="checkbox" class="priority-checkbox-native" [checked]="false" tabindex="-1"
                            [disabled]="isPriorityDisabled(form.purpose, item.id, 3)">
                        }
                        {{ item.name }}
                      </label>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="form-action">
              <button class="reset-btn" (click)="resetPriority(form.purpose)">× リセット</button>
            </div>
          </div>
        }

        <!-- 企画の概要 -->
        <div class="form-row">
          <div class="form-label text">企画の概要 <span class="required">※</span></div>
          <div class="form-field">
            <div class="field-with-count">
              <span class="char-count">{{ form.summary.length }} / 300</span>
              <textarea class="textarea-input" [(ngModel)]="form.summary" maxlength="300" rows="4" placeholder="概要を入力"></textarea>
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 社会テーマ -->
        @if (showSocialTheme) {
          <div class="form-row">
            <div class="form-label check">社会テーマ <span class="required">※</span></div>
            <div class="form-field">
              <div class="category-row">
                <div class="category-sub-area">
                  <span class="category-sub-note">
                    ※ 優先度の高い順に最大3つまで選択
                  </span>
                  <div [class]="'checkbox-grid narrow cols-' + fitGridCols(getMasterItems('social_theme'), 3, 0, 8)">
                    @for (item of getMasterItems('social_theme'); track item.id) {
                      <label class="priority-checkbox"
                        [class.checked]="isInPriority(form.socialTheme, item.id)"
                        [class.disabled]="isPriorityDisabled(form.socialTheme, item.id, 3)"
                        (click)="togglePriority(form.socialTheme, item.id, 3); $event.preventDefault()">
                        @if (getPriorityNum(form.socialTheme, item.id); as num) {
                          <span class="priority-num">{{ num }}</span>
                        } @else {
                          <input type="checkbox" class="priority-checkbox-native" [checked]="false" tabindex="-1"
                            [disabled]="isPriorityDisabled(form.socialTheme, item.id, 3)">
                        }
                        {{ item.name }}
                      </label>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="form-action">
              <button class="reset-btn" (click)="resetPriority(form.socialTheme)">× リセット</button>
            </div>
          </div>
        }

        <!-- 開催者 所属組織 -->
        <div class="form-row">
          <div class="form-label">開催者所属 <span class="required">※</span></div>
          <div class="form-field">
            <div class="organizer-unit-row">
              <span class="sub-label">組織</span>
              <div class="radio-row keep-inline">
                @for (item of getMasterItems('organizer_org_unit'); track item.id) {
                  @if (item.name !== '全体') {
                    <label class="radio-label">
                      <input type="radio" name="organizerUnit" [(ngModel)]="form.organizerUnit" [value]="item.id">
                      {{ item.name }}
                    </label>
                  }
                }
              </div>
            </div>
            <div class="organizer-detail-row">
              <span class="sub-label">詳細</span>
              <div>
                <button class="select-dialog-btn" (click)="onOpenOrgDialog('organizer')">選択</button>
                @if (showNoticeOrganizerDetail) {
                  <span class="private-notice">
                    この項目は他組織へ非公開です。
                  </span>
                }
                @if (form.organizerOrgDetailText) {
                  <div class="org-detail-lines">
                    @for (line of form.organizerOrgDetailText.split('\n'); track $index) {
                      <div class="org-detail-line-wrapper">
                        <div class="dot">・</div>
                        <div class="org-detail-line">{{ line }}</div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 対象組織 -->
        @if (showTargetOrg) {
          <div class="form-row">
            <div class="form-label" [class.btn]="!showTargetUnit">対象組織 <span class="required">※</span></div>
            <div class="form-field">
              @if (showTargetUnit) {
                <div class="organizer-unit-row">
                  <span class="sub-label">単位</span>
                  <div class="radio-row keep-inline">
                    @for (item of getMasterItems('organizer_org_unit'); track item.id) {
                      <label class="radio-label">
                        <input type="radio" name="targetUnit" [(ngModel)]="form.targetUnit" [value]="item.id">
                        {{ item.name }}
                      </label>
                    }
                  </div>
                </div>
              }
              <div class="organizer-detail-row">
                <span class="sub-label">詳細</span>
                <div>
                  <button class="select-dialog-btn" (click)="onOpenOrgDialog('target')">選択</button>
                  @if (showNoticeTargetOrganizerDetail) {
                    <span class="private-notice">
                      この項目は他組織へ非公開です。
                    </span>
                  }
                  @if (form.targetOrgDetailText) {
                    <div class="org-detail-lines">
                      @for (line of form.targetOrgDetailText.split('\n'); track $index) {
                        <div class="org-detail-line-wrapper">
                          <div class="dot">・</div>
                          <div class="org-detail-line">{{ line }}</div>
                        </div>
                      }
                    </div>
                  }
                  </div>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- 対象/参加者 -->
        @if (showTargetOrg) {
          <div class="form-row">
            <div class="form-label select">対象/参加者 <span class="required">※</span></div>
            <div class="form-field">
              <mat-form-field appearance="fill" class="no-line">
                <mat-select [(ngModel)]="form.participantCategory" (ngModelChange)="onParticipantCategoryChange()" [panelWidth]="getMasterItems('participant_category') | optionPanelWidth : 230">
                  @for (item of getMasterItems('participant_category'); track item.id) {
                    <mat-option [value]="item.id">{{ item.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              @if (form.participantCategory !== null && form.participantCategory !== 199) {
                <div class="participant-detail-section">
                  <span class="sub-label">詳細</span>
                  <!-- SPでは、文字の幅から列数を決める（組合役員の長い役職名は列の中で折り返す） -->
                  <div [class]="'checkbox-group sp-cols-' + participantDetailSpCols" [class.officer]="form.participantCategory === 196">
                    @for (item of participantDetailOptions; track item.id) {
                      <!-- 「組合員全体」を選んでいる間は、正規雇用・非正規雇用を選べないことが分かるよう灰色にする（年代の「全年代」と同じ） -->
                      <label class="checkbox-label" [class.disabled]="hasAllUnionMemberSelected() && isEmploymentType(item.id)">
                        <input type="checkbox"
                          [checked]="isMultiSelected(form.participantDetails, item.id)"
                          [disabled]="hasAllUnionMemberSelected() && isEmploymentType(item.id)"
                          (change)="toggleParticipantDetail(item.id)">
                        {{ item.name }}
                      </label>
                    }
                  </div>
                </div>
              }
            </div>
            <div class="form-action"></div>
          </div>

          @if (showAttr) {
            <div class="form-row">
              <div class="form-label padding-right"><span class="label-pc">└ 属性</span><span class="label-sp">対象/参加者の属性</span> <span class="required"></span></div>
              <div class="form-field">
                <div class="attribute-groups">
                  <div class="attr-group first">
                    <span class="sub-label">年代</span>
                    <!-- SPでは、中分類などと同じく文字の幅から列数を決める（小見出し「年代」28px＋間隔8pxを引く） -->
                    <div [class]="'checkbox-group sp-cols-' + fitGridCols(getMasterItems('attr_generation'), 4, 0, 24, 36, 22)">
                      @for (item of getMasterItems('attr_generation'); track item.id) {
                        <!-- 「中堅」以降は2行目に回す -->
                        @if (item.name.startsWith('中堅')) {
                          <span class="checkbox-row-break"></span>
                        }
                        <label class="checkbox-label" [class.disabled]="isGenerationDisabled(item.id)">
                          <input type="checkbox"
                            [checked]="isMultiSelected(form.participantAttributes, item.id)"
                            [disabled]="isGenerationDisabled(item.id)"
                            (change)="toggleGenerationAttribute(item.id)">
                          {{ item.name }}
                        </label>
                      }
                    </div>
                  </div>
                  <div class="attr-group">
                    <span class="sub-label">性別</span>
                    <div class="checkbox-group">
                      @for (item of getMasterItems('attr_gender'); track item.id) {
                        <label class="checkbox-label">
                          <input type="checkbox"
                            [checked]="isMultiSelected(form.participantAttributes, item.id)"
                            (change)="toggleMultiSelect(form.participantAttributes, item.id)">
                          {{ item.name }}
                        </label>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-action"></div>
            </div>
          }
        }

        <!-- 他労組共同開催 -->
        @if (showCompanyOtherCollaboration) {
          <div class="form-row one-row">
            <div class="form-label">他労組共同開催 <span class="required">@if(form.categoryId != 10){※}</span></div>
            <div class="form-field">
              <div class="radio-row keep-inline">
                <label class="radio-label">
                  <input
                    type="radio"
                    name="companyOtherCollaboration"
                    [(ngModel)]="form.companyOtherCollaboration" [value]="true"
                    (click)="toggleRadio($event, 'companyOtherCollaboration', true, form.categoryId == 10)">あり
                </label>

                <label class="radio-label">
                  <input
                    type="radio"
                    name="companyOtherCollaboration"
                    [(ngModel)]="form.companyOtherCollaboration" [value]="false"
                    (click)="toggleRadio($event, 'companyOtherCollaboration', false, form.categoryId == 10)">なし
                </label>
              </div>
            </div>
            <div class="form-action">
              @if (form.categoryId == 10) {
                <button class="reset-btn" (click)="form.companyOtherCollaboration = null">× リセット</button>
              }
            </div>
          </div>
        }

        <!-- 会社協働・協賛 -->
        @if (showCompanyCollaboration) {
          <div class="form-row one-row">
            <div class="form-label">会社協働・協賛 <span class="required">@if(form.categoryId != 10){※}</span></div>
            <div class="form-field">
              <div class="radio-row keep-inline">
                <label class="radio-label">
                  <input type="radio" name="companyCollaboration" [(ngModel)]="form.companyCollaboration" [value]="true"
                         (click)="toggleRadio($event, 'companyCollaboration', true, form.categoryId == 10)">あり
                </label>
                <label class="radio-label">
                  <input type="radio" name="companyCollaboration" [(ngModel)]="form.companyCollaboration" [value]="false"
                         (click)="toggleRadio($event, 'companyCollaboration', false, form.categoryId == 10)">なし
                </label>
              </div>
            </div>
            <div class="form-action">
              @if (form.categoryId == 10) {
                <button class="reset-btn" (click)="form.companyCollaboration = null">× リセット</button>
              }
            </div>
          </div>
        }

        <!-- 実施方法 -->
        <div class="form-row one-row">
          <div class="form-label">実施方法 <span class="required">※</span></div>
          <div class="form-field">
            <div class="radio-row">
              @for (item of implementationMethodBasicOptions; track item.id) {
                <label class="radio-label">
                  <input type="radio" name="implementationMethod" [(ngModel)]="form.implementationMethod" [value]="item.id">
                  {{ item.name }}
                </label>
              }
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 開催方法 -->
        @if (showHoldingMethod) {
          <div class="form-row one-row">
            <div class="form-label">開催方法 <span class="required">@if(form.categoryId == 1){※}</span></div>
            <div class="form-field">
              <div class="radio-row">
                @for (item of getMasterItems('holding_method'); track item.id) {
                  <label class="radio-label">
                    <input type="radio" name="holdingMethod" [(ngModel)]="form.holdingMethod" [value]="item.id"
                           (click)="toggleRadio($event, 'holdingMethod', item.id, form.categoryId === 10)">
                    {{ item.name }}
                  </label>
                }
              </div>
            </div>
            <div class="form-action">
              @if (form.categoryId === 10) {
                <button class="reset-btn" (click)="form.holdingMethod = null">× リセット</button>
              }
            </div>
          </div>
        }

        <!-- 教育形式 -->
        @if (showEducationFormat) {
          <div class="form-row one-row">
            <div class="form-label">教育形式 <span class="required">@if(form.categoryId == 2){※}</span></div>
            <div class="form-field">
              <div class="attribute-groups one">
                <div class="attr-group first">
                  <!-- SPでは、目的と同じく文字の幅から列数を決めて列をそろえる -->
                  <div [class]="'checkbox-group sp-cols-' + fitGridCols(getMasterItems('education_format'), 4, 0, 24, 0, 22)">
                    @for (item of getMasterItems('education_format'); track item.id) {
                      <label class="checkbox-label">
                        <input type="checkbox"
                          [checked]="isMultiSelected(form.educationFormat, item.id)"
                          (change)="toggleMultiSelect(form.educationFormat, item.id)">
                        {{ item.name }}
                      </label>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        <!-- 調査方法 -->
        @if (showSurveyMethod) {
          <div class="form-row one-row">
            <div class="form-label">調査方法 <span class="required">@if(form.categoryId != 10){※}</span></div>
            <div class="form-field">
              <div class="radio-row">
                @for (item of getMasterItems('survey_method'); track item.id) {
                  <label class="radio-label">
                    <input type="radio" name="surveyMethod" [(ngModel)]="form.surveyMethod" [value]="item.id"
                           (click)="toggleRadio($event, 'surveyMethod', item.id, form.categoryId === 10)">
                    {{ item.name }}
                  </label>
                }
              </div>
            </div>
            <div class="form-action">
              @if (form.categoryId === 10) {
                <button class="reset-btn" (click)="form.surveyMethod = null">× リセット</button>
              }
            </div>
          </div>
        }

        <!-- 案内方法 -->
        @if (showAnnouncementMethod) {
          <div class="form-row">
            <div class="form-label check">案内方法 <span class="required">※</span></div>
            <div class="form-field">
              <div class="category-row">
                <div class="category-sub-area">
                  <span class="category-sub-note">
                    ※ 優先度の高い順に最大3つまで選択
                  </span>
                  <div [class]="'checkbox-grid short-items cols-' + fitGridCols(getMasterItems('announcement_method'), 5) + ' sp-eq-' + methodSpCols">
                    @for (item of getMasterItems('announcement_method'); track item.id) {
                      <label class="priority-checkbox"
                        [class.checked]="isInPriority(form.announcementMethod, item.id)"
                        [class.disabled]="isPriorityDisabled(form.announcementMethod, item.id, 3)"
                        (click)="togglePriority(form.announcementMethod, item.id, 3); $event.preventDefault()">
                        @if (getPriorityNum(form.announcementMethod, item.id); as num) {
                          <span class="priority-num">{{ num }}</span>
                        } @else {
                          <input type="checkbox" class="priority-checkbox-native" [checked]="false" tabindex="-1"
                            [disabled]="isPriorityDisabled(form.announcementMethod, item.id, 3)">
                        }
                        {{ item.name }}
                      </label>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="form-action">
              <button class="reset-btn" (click)="resetPriority(form.announcementMethod)">× リセット</button>
            </div>
          </div>
        }

        <!-- 応募方法 -->
        @if (showRecruitmentMethod) {
          <div class="form-row">
            <div class="form-label check">応募方法 <span class="required">※</span></div>
            <div class="form-field">
              <div class="category-row">
                <div class="category-sub-area">
                  <span class="category-sub-note">
                    ※ 優先度の高い順に最大3つまで選択
                  </span>
                  <div [class]="'checkbox-grid short-items cols-' + fitGridCols(getMasterItems('recruitment_method'), 5) + ' sp-eq-' + methodSpCols">
                    @for (item of getMasterItems('recruitment_method'); track item.id) {
                      <label class="priority-checkbox"
                        [class.short-item]="item.name === '申請（紙）'"
                        [class.checked]="isInPriority(form.recruitmentMethod, item.id)"
                        [class.disabled]="isPriorityDisabled(form.recruitmentMethod, item.id, 3)"
                        (click)="togglePriority(form.recruitmentMethod, item.id, 3); $event.preventDefault()">
                        @if (getPriorityNum(form.recruitmentMethod, item.id); as num) {
                          <span class="priority-num">{{ num }}</span>
                        } @else {
                          <input type="checkbox" class="priority-checkbox-native" [checked]="false" tabindex="-1"
                            [disabled]="isPriorityDisabled(form.recruitmentMethod, item.id, 3)">
                        }
                        {{ item.name }}
                      </label>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="form-action">
              <button class="reset-btn" (click)="resetPriority(form.recruitmentMethod)">× リセット</button>
            </div>
          </div>
        }

        <!-- 会場 -->
        @if (showVenue) {
          <div class="form-row one-row top-align">
            <div class="form-label">会場 <span class="required">※</span></div>
            <div class="form-field">
              <div class="radio-row keep-inline">
                @for (item of getMasterItems('venue'); track item.id) {
                  <label class="radio-label">
                    <input type="radio" name="venue" [(ngModel)]="form.venue" [value]="item.id">
                    {{ item.name }}
                  </label>
                }
              </div>
              <!-- 詳細：施設名・住所などの任意の補足（50文字まで）。小見出しは選択肢の左端にそろえる -->
              <div class="venue-detail-row">
                <span class="sub-label">詳細</span>
                <div class="field-with-count">
                  <span class="char-count">{{ (form.venueDetail || '').length }} / 50</span>
                  <input type="text" class="text-input" [(ngModel)]="form.venueDetail" maxlength="50" placeholder="施設名・住所など ※任意登録">
                </div>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- 開催日数 + 日程 -->
        <div class="form-row">
          <div class="form-label select">開催日数<span class="required">※</span></div>
          <div class="form-field">
            <mat-form-field appearance="fill" class="no-line">
              <mat-select [(ngModel)]="form.numberOfDays" (ngModelChange)="onNumberOfDaysChange()">
                @for (opt of numberOfDaysOptions; track opt.value) {
                  <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <div class="schedule-rows">
              @for (row of scheduleRows; track row.index) {
                <div class="schedule-row">
                  <span class="sub-label">{{ row.label }}</span>
                  <!-- 日付の部分と時間の部分。1行に収まらない場合は、時間の部分を日付の位置から始まる2行目に回す -->
                  <div class="schedule-body">
                  <div class="schedule-date">
                  <div class="date-picker-trigger">
                    <button type="button" class="date-select-btn" (click)="picker.open()">日付選択</button>
                    <input [matDatepicker]="picker"
                          [ngModel]="scheduleDates[row.index]"
                          [min]="getScheduleMinDate(row.index)"
                          [max]="getScheduleMaxDate(row.index)"
                          (dateChange)="onScheduleDateChange(row.index, $event.value)"
                          class="date-picker-hidden-input"
                          readonly>
                    <mat-datepicker #picker></mat-datepicker>
                  </div>
                  <span class="schedule-date-text">{{ formatScheduleDate(row.index) }}</span>
                  </div>
                  <div class="schedule-times">
                  <!-- 開始・終了の時間は手入力（数字3〜4桁、0000〜2359。全角数字は半角に直し、3桁は頭に0をつける）。入力中は数字だけ、入力欄を離れたら（Enter でも）「09:30」の形で表示する -->
                  <span class="time-label">開始</span>
                  <mat-form-field appearance="fill" class="no-line time-select">
                    <input matInput #startTimeInput type="text" inputmode="numeric" maxlength="4" autocomplete="off"
                           placeholder="例 0930"
                           [value]="form.schedules[row.index].startTime"
                           (focus)="onTimeFocus(startTimeInput)"
                           (keydown.enter)="startTimeInput.blur()"
                           (input)="onTimeInput($event, startTimeInput)"
                           (compositionend)="onTimeInput($event, startTimeInput)"
                           (blur)="onTimeBlur(row.index, 'startTime', startTimeInput)">
                  </mat-form-field>
                  <span class="time-label">終了</span>
                  <mat-form-field appearance="fill" class="no-line time-select">
                    <input matInput #endTimeInput type="text" inputmode="numeric" maxlength="4" autocomplete="off"
                           placeholder="例 1700"
                           [value]="form.schedules[row.index].endTime"
                           (focus)="onTimeFocus(endTimeInput)"
                           (keydown.enter)="endTimeInput.blur()"
                           (input)="onTimeInput($event, endTimeInput)"
                           (compositionend)="onTimeInput($event, endTimeInput)"
                           (blur)="onTimeBlur(row.index, 'endTime', endTimeInput)">
                  </mat-form-field>
                  <span class="time-label">実施時間</span>
                  <span class="duration-text">{{ calcDuration(form.schedules[row.index]) }}</span>
                  </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 想定参加人数 -->
        @if (showEstimatedParticipants) {
          <div class="form-row">
            <div class="form-label input">想定参加人数 <span class="required">※</span></div>
            <div class="form-field">
              <div class="number-with-unit">
                <input type="text" inputmode="numeric" class="number-input short" [(ngModel)]="form.estimatedParticipants" maxlength="5" placeholder="半角数字" (input)="onEstimatedParticipantsInput($event)">
                <span class="unit">人</span>
                @if (coverageRate) {
                  <span class="calc-result"><span class="calc-label">カバー率</span>{{ coverageRate }}</span>
                }
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- 想定費用総額 -->
        @if (showCostSection) {
          <div class="form-row">
            <div class="form-label input">想定費用総額 <span class="required">@if(form.categoryId != 10){※}</span></div>
            <div class="form-field">
              <div class="number-with-unit">
                <input type="text" inputmode="numeric" class="number-input cost" [(ngModel)]="form.estimatedTotalCost" maxlength="10" placeholder="半角数字" (input)="onEstimatedTotalCostInput($event)">
                <span class="unit">円</span>
                @if (costPerPerson) {
                  <span class="calc-result"><span class="calc-label">一人当たり</span>{{ costPerPerson }}</span>
                }
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- 補助金額 -->
        @if (showSubsidyAndVendors) {
          <div class="form-row">
            <div class="form-label input">補助金額 <span class="required">@if(form.categoryId !== 10){※}</span></div>
            <div class="form-field">
              <div class="number-with-unit">
                <input type="text" inputmode="numeric" class="number-input cost" [(ngModel)]="form.subsidyAmount" maxlength="10" placeholder="半角数字" (input)="onSubsidyAmountInput($event)">
                <span class="unit">円</span>
                @if (subsidyRate) {
                  <span class="calc-result"><span class="calc-label">補助率</span>{{ subsidyRate }}</span>
                }
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- 外部業者 -->
        @if (showSubsidyAndVendors) {
          @for (vendor of form.vendors; track $index; let i = $index) {
            <div
              class="form-row"
              [class.one-row]="form.vendors.length == 0"
            >
              <div
                class="form-label text"
                [class.vendor-divider-label]="i > 0"
              >
                外部業者
                <span class="required"></span>
              </div>

              <div class="form-field">

                <div
                  class="vendor-section"
                  [class.has-divider]="i > 0"
                  [class.is-last]="i === form.vendors.length - 1"
                >

                  <div class="vendor-with-delete">

                    <div class="vendor-fields">

                      <div class="vendor-row">
                        <span class="sub-label">会社/組織名</span>
                        <div class="field-with-count">
                          <span class="char-count">
                            {{ (vendor.companyName || '').length }} / 30
                          </span>
                          <input
                            type="text"
                            class="text-input"
                            [(ngModel)]="vendor.companyName"
                            maxlength="30">
                        </div>
                      </div>

                      <div class="vendor-row">
                        <span class="sub-label">担当者</span>
                        <div class="field-with-count">
                          <span class="char-count">
                            {{ (vendor.contactPerson || '').length }} / 30
                          </span>
                          <input
                            type="text"
                            class="text-input"
                            [(ngModel)]="vendor.contactPerson"
                            maxlength="30">
                        </div>
                        <span class="private-notice text">
                          この項目は他組織へ非公開です。
                        </span>
                      </div>

                      <div class="vendor-row">
                        <span class="sub-label">連絡先</span>
                        <div class="field-with-count">
                          <span class="char-count">
                            {{ (vendor.contactInfo || '').length }} / 30
                          </span>
                          <input
                            type="text"
                            class="text-input"
                            [(ngModel)]="vendor.contactInfo"
                            maxlength="30">
                        </div>
                        <span class="private-notice text">
                          この項目は他組織へ非公開です。
                        </span>
                      </div>

                      <div class="vendor-row">
                        <span class="sub-label">担当概要</span>
                        <div class="field-with-count">
                          <span class="char-count">
                            {{ (vendor.workSummary || '').length }} / 300
                          </span>
                          <textarea
                            class="textarea-input"
                            [(ngModel)]="vendor.workSummary"
                            maxlength="300"
                            rows="3">
                          </textarea>
                        </div>
                      </div>

                      <div class="vendor-row">
                        <span class="sub-label">担当時間</span>
                        <mat-form-field appearance="fill" class="no-line vendor-margintop">
                          <mat-select [(ngModel)]="vendor.workDurationMinutes">
                            <mat-option [value]="null">選択</mat-option>
                            @for (opt of durationOptions; track opt.value) {
                              <mat-option [value]="opt.value">
                                {{ opt.label }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <div class="vendor-row">
                        <span class="sub-label">金額</span>
                        <div class="number-with-unit vendor-margintop">
                          <input
                            type="text"
                            inputmode="numeric" class="number-input cost"
                            [(ngModel)]="vendor.specificCost"
                            maxlength="10"
                            placeholder="半角数字"
                            (input)="onSpecificCostInput($event, i)">

                          <span class="unit">円</span>

                          @if (getVendorCostLabel(vendor.specificCost); as label) {
                            <span class="calc-result"><span class="calc-label short">概算</span>{{ label }}</span>
                          }

                          <span class="private-notice">
                            金額は他組織へ非公開です。<br>概算は公開されます。
                          </span>
                        </div>
                      </div>

                    </div>

                    <div class="vendor-delete">
                      <button
                        class="remove-btn"
                        (click)="removeVendor(i)">
                        × 削除
                      </button>
                    </div>

                  </div>

                </div>

              </div>
            </div>
          }

          @if (form.vendors.length < 3) {
            <div class="form-row">
              <div class="form-label"></div>

              <div
                class="form-field vendor"
                [class.vendor-empty]="form.vendors.length === 0"
              >
                <div class="add-vendor-area">
                  <button
                    class="add-vendor-btn"
                    (click)="addVendor()">
                    外部業者 追加
                  </button>
                </div>
              </div>
            </div>
          }

        }

        <!-- 実施時使用 資料/教材 -->
        <div class="form-row">
          <div class="form-label upload"><span class="label-pc">実施時使用資料<br>教材</span><span class="label-sp">実施時使用資料/教材</span> <span class="required"></span></div>
          <div class="form-field">
            <input type="file" #fileInput1 hidden
                   accept=".pdf,.jpg,.jpeg,.png,.ppt,.pptx,.xls,.xlsx,.doc,.docx"
                   (change)="onFileSelected($event, 1)">
            <div class="upload-note-row">
              <span class="file-note"><span class="file-note-mark">※</span> <span>3点まで、各10M以内、拡張子：pdf、jpg、png、ppt、pptx、xls、xlsx、doc、docx</span></span>
            </div>
            <div class="upload-btn-area">
              <div class="upload-btn-wrap">
                <button class="upload-btn" (click)="onFileUpload(1)" [disabled]="(attachments[1].length >= 3) || uploadingCategory === 1">アップロード</button>
                <!-- アップロード中はボタンの右にスピナーを出す（ボタンは消さずに押せない状態にする。スピナーの場所は常に確保） -->
                <div class="upload-spinner-slot">
                  @if (uploadingCategory === 1) {
                    <mat-spinner diameter="20"></mat-spinner>
                  }
                </div>
              </div>
              @if (showNoticeOrganizerDetail) {
                <span class="private-notice">
                  ファイルは他組織へ非公開です。
                </span>
              }
            </div>
            @if (attachments[1].length > 0) {
              <div class="attachment-list">
                @for (att of attachments[1]; track $index; let i = $index) {
                  <div class="attachment-item">
                    <span class="attachment-name" [class.attachment-link]="att.downloadUrl" (click)="onDownloadAttachment(att)">{{ att.fileName }}</span>
                    <button class="remove-btn" (click)="removeAttachment(1, i)"><i class="material-icons">close</i></button>
                  </div>
                }
              </div>
            }
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 実施する際の課題 -->
        <div class="form-row">
          <div class="form-label text">実施する際の課題 <span class="required"></span></div>
          <div class="form-field">
            <div class="field-with-count">
              <span class="char-count">{{ form.implementationChallenges.length }} / 300</span>
              <textarea class="textarea-input" [(ngModel)]="form.implementationChallenges" maxlength="300" rows="3"></textarea>
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 対策 -->
        <div class="form-row">
          <div class="form-label text">対策 <span class="required"></span></div>
          <div class="form-field">
            <div class="field-with-count">
              <span class="char-count">{{ form.countermeasures.length }} / 300</span>
              <textarea class="textarea-input" [(ngModel)]="form.countermeasures" maxlength="300" rows="3"></textarea>
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 該当職場の想定議題 -->
        @if (showWorkplaceSection) {
          <div class="form-row">
            <div class="form-label text">該当職場の想定議題 <span class="required">※</span></div>
            <div class="form-field">
              <div class="field-with-count">
                <span class="char-count">{{ form.workplaceExpectedIssues.length }} / 300</span>
                <textarea class="textarea-input" [(ngModel)]="form.workplaceExpectedIssues" maxlength="300" rows="3"></textarea>
              </div>
            </div>
            <div class="form-action"></div>
          </div>

          <!-- 重点ヒアリング項目 -->
          <div class="form-row">
            <div class="form-label text">重点ヒアリング項目 <span class="required">※</span></div>
            <div class="form-field">
              <div class="field-with-count">
                <span class="char-count">{{ form.keyHearingItems.length }} / 300</span>
                <textarea class="textarea-input" [(ngModel)]="form.keyHearingItems" maxlength="300" rows="3"></textarea>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- 効果測定 -->
        @if (showEffectiveness) {
          <div class="form-row one-row">
            <div class="form-label">効果測定 <span class="required">@if(form.categoryId != 10){※}</span></div>
            <div class="form-field">
              <!-- SPでは、目的と同じく文字の幅から列数を決めて列をそろえる -->
              <div [class]="'radio-row stack-sp sp-cols-' + fitGridCols(getMasterItems('effectiveness_measurement'), 4, 0, 24, 0, 21)">
                @for (item of getMasterItems('effectiveness_measurement'); track item.id) {
                  <label class="radio-label">
                    <input type="radio" name="effectivenessMeasurement" [(ngModel)]="form.effectivenessMeasurement" [value]="item.id"
                           (click)="toggleRadio($event, 'effectivenessMeasurement', item.id, form.categoryId === 10)">
                    {{ item.name }}
                  </label>
                }
              </div>
            </div>
            <div class="form-action">
              @if (form.categoryId === 10) {
                <button class="reset-btn" (click)="form.effectivenessMeasurement = null">× リセット</button>
              }
            </div>
          </div>
        }

        <!-- 会議体・対応形式 -->
        @if (showMeetingSection) {
          <div class="form-row one-row top-align">
            <div class="form-label">会議体・対応形式 <span class="required">※</span></div>
            <div class="form-field">
              <!-- SPでは、教育形式と同じく文字の幅から列数を決めて列をそろえる -->
              <div [class]="'checkbox-group meeting-format-group sp-cols-' + fitGridCols(getMasterItems('meeting_format'), 4, 0, 24, 0, 22)">
                @for (item of getMasterItems('meeting_format'); track item.id) {
                  <label class="checkbox-label">
                    <input type="checkbox" [checked]="isMultiSelected(form.meetingFormats, item.id)" (change)="toggleMultiSelect(form.meetingFormats, item.id)">
                    {{ item.name }}
                  </label>
                }
              </div>
            </div>
            <div class="form-action"></div>
          </div>

          <!-- 主な相手区分（選択肢が折り返したときは、会議体と同じく項目名を上端にそろえる） -->
          <div class="form-row one-row top-align">
            <div class="form-label">主な相手区分 <span class="required">※</span></div>
            <div class="form-field">
              <!-- SPでは、教育形式と同じく文字の幅から列数を決めて列をそろえる -->
              <div [class]="'checkbox-group sp-cols-' + fitGridCols(getMasterItems('counterpart_type'), 4, 0, 24, 0, 22)">
                @for (item of getMasterItems('counterpart_type'); track item.id) {
                  <label class="checkbox-label">
                    <input type="checkbox" [checked]="isMultiSelected(form.counterpartTypes, item.id)" (change)="toggleMultiSelect(form.counterpartTypes, item.id)">
                    {{ item.name }}
                  </label>
                }
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- 企画/検討資料など -->
        <div class="form-row">
          <div class="form-label upload">企画/検討資料など <span class="required"></span></div>
          <div class="form-field">
            <input type="file" #fileInput2 hidden
                   accept=".pdf,.jpg,.jpeg,.png,.ppt,.pptx,.xls,.xlsx,.doc,.docx"
                   (change)="onFileSelected($event, 2)">
            <div class="upload-note-row">
              <span class="file-note"><span class="file-note-mark">※</span> <span>3点まで、各10M以内、拡張子：pdf、jpg、png、ppt、pptx、xls、xlsx、doc、docx</span></span>
            </div>
            <div class="upload-btn-area">
              <div class="upload-btn-wrap">
                <button class="upload-btn" (click)="onFileUpload(2)" [disabled]="(attachments[2].length >= 3) || uploadingCategory === 2">アップロード</button>
                <!-- アップロード中はボタンの右にスピナーを出す（ボタンは消さずに押せない状態にする。スピナーの場所は常に確保） -->
                <div class="upload-spinner-slot">
                  @if (uploadingCategory === 2) {
                    <mat-spinner diameter="20"></mat-spinner>
                  }
                </div>
              </div>
              @if (showNoticeOrganizerDetail) {
                <span class="private-notice">
                  ファイルは他組織へ非公開です。
                </span>
              }
            </div>
            @if (attachments[2].length > 0) {
              <div class="attachment-list">
                @for (att of attachments[2]; track $index; let i = $index) {
                  <div class="attachment-item">
                    <span class="attachment-name" [class.attachment-link]="att.downloadUrl" (click)="onDownloadAttachment(att)">{{ att.fileName }}</span>
                    <button class="remove-btn" (click)="removeAttachment(2, i)"><i class="material-icons">close</i></button>
                  </div>
                }
              </div>
            }
          </div>
          <div class="form-action"></div>
        </div>

        <!-- メモ -->
        <div class="form-row">
          <div class="label-row">
            <div class="form-label memo">メモ <span class="required"></span></div>
            @if (showNoticeOrganizerDetail) {
              <span class="private-notice memo">
                他組織へ非公開
              </span>
            }
          </div>
          <div class="form-field">
            <div class="field-with-count">
              <span class="char-count">{{ form.memo.length }} / 10000</span>
              <textarea class="textarea-input" [(ngModel)]="form.memo" maxlength="10000" rows="6"></textarea>
            </div>
          </div>
          <div class="form-action"></div>
        </div>

      </div>
    </div>
  </div>
}
